import { useSmoothScroll } from "@/lib/useSmoothScroll";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { MeetNicole } from "@/components/site/MeetNicole";
import { Services } from "@/components/site/Services";
import { TrustBar } from "@/components/site/TrustBar";
import { Testimonials } from "@/components/site/Testimonials";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { Phone } from "lucide-react";
import { BUSINESS } from "@/data/site";

export default function Landing() {
  useSmoothScroll();

  return (
    <div className="App">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <MeetNicole />
        <Services />
        <TrustBar />
        <Testimonials />
        <Contact />
      </main>
      <Footer />

      <a
        href={BUSINESS.phoneHref}
        data-testid="sticky-call-cta"
        className="sm:hidden fixed bottom-5 left-1/2 -translate-x-1/2 z-40 inline-flex items-center gap-2 rounded-full bg-sage text-white px-6 py-3.5 font-medium soft-shadow-lg"
      >
        <Phone className="h-4 w-4" /> Call Nicole
      </a>
    </div>
  );
}
